export type PolicyDivision = "People & Culture" | "Transformation & IT";

export const POLICY_DIVISIONS: PolicyDivision[] = ["People & Culture", "Transformation & IT"];

export interface PolicyDocument {
  id: string;
  fileName: string;
  /** Undefined for documents uploaded before divisions existed. */
  division?: PolicyDivision;
  fileSizeBytes: number;
  uploadedAt: string;
  uploadedByUserId: string;
}
